import React, { useState } from 'react';
import './StepTypeHub.scss';

type HubSectionProps = {
  title: string;
  summary?: string;
  errorText?: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
};

export function HubSection({
  title, summary, errorText, children, defaultOpen = false,
}: HubSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggle = () => setIsOpen((prev) => !prev);

  const headerClassName = errorText
    ? 'hub-section-header hub-section-header--error'
    : 'hub-section-header';

  return (
    <div className="hub-section">
      <div
        className={headerClassName}
        role="button"
        tabIndex={0}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        }}
      >
        <h6>{title}</h6>
        {summary && <small className="text-muted hub-section-summary">{summary}</small>}
        {errorText && <small className="hub-section-summary--error">{errorText}</small>}
      </div>
      {isOpen && (
        <div className="hub-section-body">
          {children}
        </div>
      )}
    </div>
  );
}
